export default __webpack_public_path__ + "static/media/Bein-Coverlinkedin1.5018728b.png";